import { useMemo, useState } from "react";
import { CreateCartPayload } from "shared/api/middleware-api-client";
import { useStandardProductType } from "./useStandardProductType";

export enum StandardProductReceiveMethod {
  DELIVERY = "DELIVERY",
  DELIVERYWITHASSEMBLY = "DELIVERYWITHASSEMBLY",
  PICK_UP_ESD = "PICK_UP_ESD",
  PICK_UP_VILLAARENA = "PICK_UP_VILLAARENA",
}
export function useStandardProductReceiveMethod(cart: CreateCartPayload) {
  const productAnalysis = useStandardProductType(cart);
  const currentStandardProductReceiveMethod = useMemo(() => {
    if (!cart.pickupWarehouse && cart.withAssembly === true) {
      return StandardProductReceiveMethod.DELIVERYWITHASSEMBLY;
    }

    if (cart.pickupWarehouse === "ESD") {
      return StandardProductReceiveMethod.PICK_UP_ESD;
    }
    if (cart.pickupWarehouse === "VillaArena") {
      return StandardProductReceiveMethod.PICK_UP_VILLAARENA;
    }
    if (
      (!cart.pickupWarehouse && cart.withAssembly === false) ||
      (productAnalysis.someAccessoire &&
        !productAnalysis.someAkoestischepanelen)
    ) {
      return StandardProductReceiveMethod.DELIVERY;
    }
  }, [
    cart.pickupWarehouse,
    cart.withAssembly,
    productAnalysis.someAccessoire,
    productAnalysis.someAkoestischepanelen,
  ]);
  return currentStandardProductReceiveMethod;
}
